export default __webpack_public_path__ + "static/media/Warglory Vambraces.31fe52c6.jpg";